import React from 'react'; 
import { useAuth } from "../../context/AuthProvider/useAuth";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import './CommandBar.css';
import { TranslatorS } from '../../components/I18n';
import { Logout, ManageAccounts, PlayArrow, Translate } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { PaperLayer } from './components/PaperLayer';
import { OuterMenuListing } from './components/OutMenuListing';
import { InnerMenuListing } from './components/InnerMenuListing';
import { OuterMenuWrapper } from './components/OuterMenuWrapper';
import { InnerMenuWrapper } from './components/InnerMenuWrapper';
import { VersionMenuItem } from './components/VersionMenuItem';

export type OuterMenuItemTypes = {
  criteria: boolean;
  openSubMenu?: boolean;
  text: string;
  onClick: (e: any) => void;
  icon: JSX.Element;
  optionalIcon?: JSX.Element;
}

export type InnerMenuItemTypes = {
  languageText: string;
  languageValue: string;
}

const CommandBar = () => {

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [anchorElLanguage, setAnchorElLanguage] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const openLanguage = Boolean(anchorElLanguage);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleClickLanguage = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElLanguage(event.currentTarget);
  };
  const handleCloseLanguage = () => {
    setAnchorElLanguage(null);
  };
  const ITEM_HEIGHT = 48;
  const auth = useAuth();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const logout = (event: any) => {
    event.preventDefault();

    auth.logout();
    window.history.replaceState(null, '', '/login');
    if (!auth.token) {
      return <Navigate to="/login" replace />;
    }
    return true;
  };

  const outerMenuItems: OuterMenuItemTypes[] = [
    {
      criteria: false,
      text: t("MyData.Mydata"),
      onClick: () => {navigate(`mydata`); handleClose()},
      icon: <ManageAccounts />
    },
    {
      criteria: false,
      openSubMenu: openLanguage,
      text: t("MyData.Language"),
      onClick: handleClickLanguage,
      icon: <Translate />,
      optionalIcon: <PlayArrow />
    },
    {
      criteria: false,
      text: TranslatorS({path:"Sair.message"}),
      onClick: logout,
      icon: <Logout />
    },
  ];

  const innerMenuItems: InnerMenuItemTypes[] = [
    {
      languageText: "English (EN)",
      languageValue: "en-US"
    },
    {
      languageText: "Espanõl (ES)",
      languageValue: "es"
    },
    {
      languageText: "Português (BR)",
      languageValue: "pt-BR"
    }
    
  ];

  return (
      <>
        <PaperLayer 
          open={open}
          handleClick={handleClick}
        />
        <OuterMenuWrapper
          anchorEl={anchorEl}
          handleClose={handleClose}
          height={ITEM_HEIGHT}
          open={open}
        >
          <OuterMenuListing
            outerMenuItems={outerMenuItems}
          />
          <VersionMenuItem />
          <InnerMenuWrapper
            anchorEl={anchorElLanguage}
            handleClose={handleCloseLanguage}
            height={ITEM_HEIGHT}
            open={openLanguage}
          >
            <InnerMenuListing 
            handleClose={()=> {handleClose();handleCloseLanguage()}}
              innerMenuItems={innerMenuItems}
            />
          </InnerMenuWrapper>
        </OuterMenuWrapper>
      </>
  );
}

export default CommandBar;
